import {
  useEffect,
  useState
} from "react";

function Modal({
  children,
  onClose
}) {

  const [visible, setVisible] =
    useState(false);

  // =====================
  // OPEN
  // =====================

  useEffect(() => {

    const timer =
      setTimeout(
        () =>
          setVisible(
            true
          ),
        10
      );

    return () =>
      clearTimeout(
        timer
      );

  }, []);

  // =====================
  // CLOSE
  // =====================

  const handleClose =
    () => {

      setVisible(false);

      setTimeout(
        onClose,
        200
      );
    };

  // =====================
  // RENDER
  // =====================

  return (
    <div
      onClick={
        handleClose
      }
      className={`fixed inset-0 z-50 bg-black/50 flex justify-center transition-all duration-200 ${
        visible
          ? "opacity-100"
          : "opacity-0"
      } items-end md:items-center`}
    >

      <div
        onClick={(e) =>
          e.stopPropagation()
        }
        className={`bg-white w-full md:w-[95%] max-w-lg max-h-[90vh] md:max-h-[85vh] rounded-t-3xl md:rounded-2xl shadow-2xl overflow-hidden flex flex-col transition-all duration-200 ${
          visible
            ? "translate-y-0"
            : "translate-y-full md:translate-y-8"
        }`}
      >

        {/* BAR MOBILE */}
        <div className="md:hidden flex justify-center py-3">

          <div className="w-12 h-1.5 bg-gray-300 rounded-full" />

        </div>

        {/* CONTENT */}
        <div className="overflow-y-auto flex-1">

          {children}

        </div>

      </div>

    </div>
  );
}

export default Modal;